import { useEffect, useMemo } from "react";
import debounce from "lodash.debounce";
import Cookies from "js-cookie";
import { DEVICE_SCREEN_SIZE_COOKIE, DEVICE_SCREEN_SIZE_COOKIE_EXPIRES_DAYS } from "@/data/constants";
const SCREEN_SIZE_WRITE_DELAY = 500;

const persistScreenSize = (width: number) => {
  const widthStr = String(width);
  if (Cookies.get(DEVICE_SCREEN_SIZE_COOKIE) === widthStr) return;

  Cookies.set(DEVICE_SCREEN_SIZE_COOKIE, widthStr, {
    expires: DEVICE_SCREEN_SIZE_COOKIE_EXPIRES_DAYS,
    sameSite: "lax",
    path: "/",
  });
};

export const useDeviceLayoutCookie = () => {
  const writeCookie = () => {
    if (typeof window === "undefined") return;
    const measuredWidth = window.innerWidth;
    if (!Number.isFinite(measuredWidth)) return;
    persistScreenSize(measuredWidth);
  };

  const debouncedWrite = useMemo(
    () => debounce(writeCookie, SCREEN_SIZE_WRITE_DELAY),
    [writeCookie],
  );

  useEffect(() => {
    writeCookie();
    window.addEventListener("resize", debouncedWrite);

    return () => {
      window.removeEventListener("resize", debouncedWrite);
      debouncedWrite.cancel();
    };
  }, [debouncedWrite, writeCookie]);
};
